import React, { useContext, useEffect, useState } from "react";
import styles from './style.module.css';
import { AuthContext } from "../../authContext";
import useStore from "../../store/store";
import serverPath from "../../utils/serverPath";
import { NavLink } from "react-router-dom";
import SweetAlert from "../../Components/SweetAlert";
import CurrencyArranger from "../../utils/CurrencyArranger";
const CurrencyRate = (props) =>
{
  const context = useContext(AuthContext);
  const [globalState, dispatch] = useStore();
  const {currencies, currencyRates} = globalState;
  const [currencytable, setCurrencyTable] = useState(null);
  const [oldSearch, setOldSearch] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const initialFields = {
    fromCurrency: currencies[1]?.id,
    toCurrency: currencies[0]?.id,
    toCurrencies: [],
    count: 0,
    pageNumber: 1,
    province: "None",
    data: [...currencyRates],
  };
  const [fields, setFields] = useState({...initialFields});
  let provinces = ["Kabul", "Kandahar", "Herat", "Mazar-i-Sharif", "Jalalabad"];

  useEffect(() =>
  {
    // if (currencyRates.length > 0 && fields.data.length <= 0)
    //   changeHandler(currencyRates, "data");

    if(fields.data.length > 0)
    {
      let tables = window.loadTable();
      setCurrencyTable(tables.tableExport);
    }
  }, [fields.data]);
  useEffect(() =>
  {
    toCurrencyArranger(currencies[1]?.id);
    window.loadForm();
  }, []);

  const toCurrencyArranger = (newFromCurrency) =>
  {
    let currency = globalState.currencies.find(curr => curr.id === newFromCurrency);
    const moreCurrency = CurrencyArranger.find(per => per.parentCurrency === currency?.code);
    let childCurrencies = [];
    moreCurrency?.children?.forEach(element => {
      const isCurrencyExist = globalState.currencies.find(curr => curr?.code === element);
      if (isCurrencyExist)
        childCurrencies.push(isCurrencyExist);
    });

    changeHandler(childCurrencies, "toCurrencies");
    return childCurrencies;
  }

  const currencyChangeRequest = async (newData) =>
  {
    try {
        setIsLoading(true);

        const bodyData = {
          fromCurrencyId: fields.fromCurrency,
          toCurrencyId: fields.toCurrency,
          limit: 100,
          ...(fields.province !== "None" && { province: fields.province })
        };
        bodyData[newData.type] = newData.value;

        if (newData.type === "fromCurrencyId")
        {
          // bodyData["toCurrencyId"] = toCurrencyArranger(Number.parseInt(newData.value))[0]?.id;
          toCurrencyArranger(Number.parseInt(newData.value));
        } else if (newData.type === "province" && newData.value === "None") {
          delete bodyData.province;
        }

        console.log(bodyData, "bodyData");
        

        const {data, status, message} = await (await fetch(serverPath("/get/currency_rate"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyData)
        })).json();
        
        if(status === "failure")
          console.log(message)
          
        if(status === "success")
        {
          if (data.count >= 1)
          {
            currencytable?.destroy();
            changeHandler(data.count, "count");
            changeHandler(data.rows, "data");
            const merged = [...currencyRates, ...data.rows];
            const uniqueRates = Array.from(new Map(merged.map(item => [item.id, item])).values());
            dispatch('setData', {type: 'currencyRates', data: uniqueRates});
          } else {
            SweetAlert("info", "Nothing Found On Currency");
          }
        }
      } catch (error) {
        console.log(error.message)
      }
      setIsLoading(false);
  }

  const loadNewData = async () =>
  {
    if(isLoading)
      return;

    if((Math.ceil(fields.count / 100)) < fields.pageNumber)
      return SweetAlert("info", "You Entered Wrong Page Number")

    try {
      setIsLoading(true);
      const {data, status} = await (await fetch(serverPath("/get/currency_rate"), {
        method: "POST",
        headers: {
          "Content-Type": "Application/JSON",
          "Authorization": `bearer ${localStorage.getItem("A_TOKEN")}`
        },
        body: JSON.stringify({fromCurrencyId: fields.fromCurrency, toCurrencyId: fields.toCurrency, ...(fields.province !== "None" && { province: fields.province }), pageNumber: fields.pageNumber})
      })).json();

      if(status === "success")
        if(data.count >= 1)
        {
          currencytable?.destroy();
          changeHandler(data.count, "count");
          changeHandler(data.rows, "data");
          const merged = [...currencyRates, ...data.rows];
          const uniqueRates = Array.from(new Map(merged.map(item => [item.id, item])).values());
          dispatch('setData', {type: 'currencyRates', data: uniqueRates});
        } else {
          SweetAlert("info", "Nothing Found On Currency");
        }
      } catch (error) {
          SweetAlert("warning", error.message)
      }
      setIsLoading(false);
  };

  const changeHandler = (value, type) =>
  {
    setFields(prev => ({...prev, [type]: value}));
  }

  return (
    <div className="main-content">
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>Find By Filter</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-12">
                      <div className="row">
                        <div className="col-11">
                          <label>From Currency</label>
                          <select className="form-control" value={fields.fromCurrency} onChange={({target}) => {
                            if (Number.parseInt(fields.toCurrency) !== Number.parseInt(target.value))
                            {
                              changeHandler(target.value, "fromCurrency");
                              currencyChangeRequest({type: "fromCurrencyId", value: target.value});
                            }
                          }}>
                            {currencies.map(currency => (
                              <option value={currency.id} key={currency.id}>{currency?.code}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-12">
                      <div className="row">
                        <div className="col-11">
                          <label>To Currency</label>
                          <select className="form-control" value={fields.toCurrency} onChange={({target}) => {
                            if (Number.parseInt(fields.fromCurrency) !== Number.parseInt(target.value))
                            {
                              changeHandler(target.value, "toCurrency");
                              currencyChangeRequest({type: "toCurrencyId", value: target.value});
                            }
                          }}>
                            {
                              fields.toCurrencies.map((currency, index) => (
                                <option value={currency.id} key={currency.id}>{currency?.code}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-lg-4 col-md-6 col-12">
                      <div className="row">
                        <div className="col-11">
                          <label>Province</label>
                          <select className="form-control" value={fields.province} onChange={({target}) => {
                            changeHandler(target.value, "province");
                            currencyChangeRequest({type: "province", value: target.value});
                          }}>
                            <option value={"None"}>None</option>
                            {provinces.map(province => (
                              <option value={province} key={province}>{province}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    {fields.count >= 1 && <div className="row col-lg-7 col-md-7 col-12" style={{ alignItems: "center" }}>
                      <div className="col-lg-4 col-md-4 col-12">
                        Max Page Number <strong>{(Math.ceil(fields.count / 100) || 1)}</strong>
                      </div>
                      <div className="col-lg-3 col-md-3 col-12">
                        <input
                          type="number" className="form-control" value={fields.pageNumber} min={1} max={(Math.ceil(fields.count / 100) || 1)} onChange={({ target }) =>
                            changeHandler(target.value.replace(/[\D]/ig, ""), "pageNumber")
                          }
                        />
                      </div>
                      <div className="col-lg-5 col-md-5 col-12 mt-2 mt-md-0">
                        <button className="btn btn-primary w-100" type="button" onClick={loadNewData}>
                          Load New Data
                        </button>
                      </div>
                    </div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>Currency Rate</h4>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-hover" id="tableExport">
                      <thead>
                        <tr>
                          <th className="text-center">
                            #
                          </th>
                          <th>Province</th>
                          <th>Buy</th>
                          <th>Sell</th>
                          <th>Date Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields.data.map((currencyRate, index) => {
                          return (
                            <tr key={currencyRate.id}>
                              <td>
                                {(index + 1)}
                              </td>
                              <td>{currencyRate.province}</td>
                              <td>{currencyRate.buy}</td>
                              <td>{currencyRate.sell}</td>
                              <td>{new Date(currencyRate.dateTime).toLocaleString().replace(/\//g, "-")}</td>
                              <td><NavLink to={`/currencyRate/edit/${currencyRate.id}`} className="btn btn-primary">Edit / Delete</NavLink></td>
                            </tr>
                          )})}
                      </tbody>
                    </table>
                    <div>
                      <p>Total currency rates: {fields.count}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
      </section>
    </div>
  )
}


export default CurrencyRate;